import React, { useEffect, useRef, useState } from 'react';
import { useUser } from '../context/UserContext';
import '../pages/Dashboard.css';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const CityMapSlider = () => {
  const [activeCity, setActiveCity] = useState('bangalore');
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const [bangaloreLocations, setBangaloreLocations] = useState([]);
  const [hyderabadLocations, setHyderabadLocations] = useState([]);
  const [tamilnaduLocations, setTamilnaduLocations] = useState([]);
  const [puneLocations, setPuneLocations] = useState([]);
  const [otherLocations, setOtherLocations] = useState([]);
  const bangaloreMapRef = useRef(null);
  const hyderabadMapRef = useRef(null);
  const tamilnaduMapRef = useRef(null);
  const puneMapRef = useRef(null);
  const otherMapRef = useRef(null);
  const bangaloreMapInstance = useRef(null);
  const hyderabadMapInstance = useRef(null);
  const tamilnaduMapInstance = useRef(null);
  const puneMapInstance = useRef(null);
  const otherMapInstance = useRef(null);
  const sliderRef = useRef(null);
  const token = localStorage.getItem('auth-token');
  const CITY_CENTERS = {
    bangalore: { lat: 12.9716, lng: 77.5946, radius: 50 },
    hyderabad: { lat: 17.3850, lng: 78.4867, radius: 50 },
    tamilnadu: { lat: 11.0168, lng: 76.9558, radius: 200 },
    pune: { lat: 18.5204, lng: 73.8567, radius: 50 }
  };

  const calculateDistance = (lat1, lon1, lat2, lon2) => {
    const R = 6371;
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;
    const a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
      Math.sin(dLon/2) * Math.sin(dLon/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c;
  };

  const getCityFromCoordinates = (lat, lng) => {
    if (!lat || !lng) return 'other';
    
    let closestCity = 'other';
    let minDistance = Infinity;
    
    for (const [city, center] of Object.entries(CITY_CENTERS)) {
      const distance = calculateDistance(lat, lng, center.lat, center.lng);
      
      if (distance <= center.radius && distance < minDistance) {
        minDistance = distance;
        closestCity = city;
      }
    }
    
    return closestCity;
  };

  useEffect(() => {
    const fetchAcademies = async () => {
      try {
        const { data } = await axios.get(
          process.env.REACT_APP_API_ACADEMY2,
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
          }
        );

        if (data.success) {
          const bangalore = [];
          const hyderabad = [];
          const tamilnadu = [];
          const pune = [];
          const other = [];

          data.data.academies.forEach(a => {
            const lat = parseFloat(a.latitude) || 0;
            const lng = parseFloat(a.longitude) || 0;
            const city = getCityFromCoordinates(lat, lng);
            
            const academyData = {
              id: a.id,
              name: a.name,
              lat: lat,
              lng: lng,
              icon: '🏫',
              animation: '',
              address: a.address,
              contactNumber: a.contactNumber
            };

            switch(city) {
              case 'bangalore':
                if (!a.name.startsWith('National Public School')) {
                  bangalore.push(academyData);
                }
                break;
              case 'hyderabad':
                hyderabad.push(academyData);
                break;
              case 'tamilnadu':
                tamilnadu.push(academyData);
                break;
              case 'pune':
                pune.push(academyData);
                break;
              default:
                other.push(academyData);
                break;
            }
          });

          // Add the specific Pune location manually to ensure it's included
          const puneAcademy = {
            id: 113,
            name: "Machaxi LeNoah, Sports Health & Fitness Club",
            lat: 18.59843,
            lng: 73.7291,
            icon: '🏫',
            animation: '',
            address: "Phase 1, Hinjawadi Rajiv Gandhi Infotech Park, Hinjawadi, Pune, Pimpri-Chinchwad, Maharashtra 411057",
            contactNumber: "9355057527"
          };
          
          // Check if it already exists to avoid duplicates
          const puneExists = pune.some(loc => loc.id === 113);
          if (!puneExists) {
            pune.push(puneAcademy);
          }

          setBangaloreLocations(bangalore);
          setHyderabadLocations(hyderabad);
          setTamilnaduLocations(tamilnadu);
          setPuneLocations(pune);
          setOtherLocations(other);
        
        }
      } catch (err) {
        console.error('API call error:', err);
      }
    };

    fetchAcademies();
  }, []);

  useEffect(() => {
    if (window.google && window.google.maps) {
      setScriptLoaded(true);
      return;
    }
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAdy0zh69w3bYrzIMxuISgN_5V-PWA17RI&libraries=geometry`;
    script.async = true;
    script.defer = true;
    script.onload = () => setScriptLoaded(true);
    document.head.appendChild(script);
  }, []);

  const createMarkerContent = loc => `
    <div class="custom-marker">
      <div class="map-city">
        <div class="map-city__label">
          <span
            data-icon="${loc.icon}"
            class="map-city__sign ${loc.animation ? 'anim ' + loc.animation : ''}"
          >
            ${loc.name}
          </span>
        </div>
      </div>
    </div>
  `;

  const initializeMap = (mapRef, center, zoom) => {
    if (!scriptLoaded || !mapRef.current) return;
    const isMobile = /Mobi|Android/i.test(navigator.userAgent);

    return new window.google.maps.Map(mapRef.current, {
      center: center,
      zoom: zoom,
      mapTypeId: 'roadmap',
      styles: [
        { featureType: 'poi', elementType: 'all', stylers: [{ visibility: 'off' }] },
        { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#c9e6ff' }] },
        { featureType: 'landscape', elementType: 'geometry', stylers: [{ color: '#f2f2f2' }] },
        { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }, { visibility: 'simplified' }] },
        { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#8b8b8b' }] },
        { featureType: 'road', elementType: 'labels.text.stroke', stylers: [{ color: '#ffffff' }] },
        { featureType: 'transit', elementType: 'geometry', stylers: [{ visibility: 'off' }] },
        { featureType: 'administrative', elementType: 'geometry', stylers: [{ color: '#cccccc' }] },
      ],
      disableDefaultUI: !isMobile,
    zoomControl: true,
    mapTypeControl: isMobile,
    streetViewControl: isMobile,
    fullscreenControl: isMobile,
    scaleControl: isMobile,
    rotateControl: isMobile,
    disableDoubleClickZoom: true,
    gestureHandling: "auto",
    });
  };

  useEffect(() => {
    bangaloreMapInstance.current = initializeMap(
      bangaloreMapRef, 
      { lat: 12.9716, lng: 77.5946 }, 
      11.6
    );
  }, [scriptLoaded]);

  useEffect(() => {
    hyderabadMapInstance.current = initializeMap(
      hyderabadMapRef, 
      { lat: 17.3850, lng: 78.4867 }, 
      11
    );
  }, [scriptLoaded]);

  useEffect(() => {
    tamilnaduMapInstance.current = initializeMap(
      tamilnaduMapRef, 
      { lat: 11.0168, lng: 76.9558 }, 
      10
    );
  }, [scriptLoaded]);

  useEffect(() => {
    puneMapInstance.current = initializeMap(
      puneMapRef, 
      { lat: 18.5204, lng: 73.8567 }, 
      11
    );
  }, [scriptLoaded]);

  useEffect(() => {
    otherMapInstance.current = initializeMap(
      otherMapRef, 
      { lat: 20.5937, lng: 78.9629 }, 
      5
    );
  }, [scriptLoaded]);

  const addMarkersToMap = (mapInstance, locations) => {
    if (!mapInstance || !mapInstance.current || locations.length === 0) return;

    locations.forEach(loc => {
      const position = new window.google.maps.LatLng(loc.lat, loc.lng);
      const overlay = new window.google.maps.OverlayView();

      overlay.onAdd = function() {
        const div = document.createElement('div');
        div.className = 'custom-marker-container';
        div.innerHTML = createMarkerContent(loc);
        this.getPanes().floatPane.appendChild(div);
        this.div = div;
      };

      overlay.draw = function() {
        const point = this.getProjection().fromLatLngToDivPixel(position);
        if (!point || !this.div) return;
      
        const mapDiv = mapInstance.current.getDiv();
        const mapW = mapDiv.offsetWidth;
        const labelW = this.div.offsetWidth;
      
        const overflowsLeft = point.x - labelW / 2 < 0;
        const overflowsRight = point.x + labelW / 2 > mapW;
      
        if (overflowsLeft || overflowsRight) {
          this.div.classList.add('flip-label');
        } else {
          this.div.classList.remove('flip-label');
        }
      
        this.div.style.left = point.x + 'px';
        this.div.style.top = point.y + 'px';
      };

      overlay.onRemove = function() {
        if (this.div) this.div.remove();
      };

      overlay.setMap(mapInstance.current);
    });
  };

  useEffect(() => {
    if (!scriptLoaded) return;
    
    addMarkersToMap(bangaloreMapInstance, bangaloreLocations);
    addMarkersToMap(hyderabadMapInstance, hyderabadLocations);
    addMarkersToMap(tamilnaduMapInstance, tamilnaduLocations);
    addMarkersToMap(puneMapInstance, puneLocations);
    addMarkersToMap(otherMapInstance, otherLocations);
  }, [scriptLoaded, bangaloreLocations, hyderabadLocations, tamilnaduLocations, puneLocations, otherLocations]);

  const handleCityChange = (city) => {
    setActiveCity(city);
    if (sliderRef.current) {
      const cities = ['bangalore', 'hyderabad', 'tamilnadu', 'pune', 'other'];
      const slideIndex = cities.indexOf(city);
      sliderRef.current.scrollTo({
        left: sliderRef.current.offsetWidth * slideIndex,
        behavior: 'smooth'
      });
    }
    switch (city) {
      case 'bangalore':
        if (bangaloreMapInstance.current) {
          bangaloreMapInstance.current.setCenter({ lat: 12.9716, lng: 77.5946 });
          bangaloreMapInstance.current.setZoom(11.6);
        }
        break;
      case 'hyderabad':
        if (hyderabadMapInstance.current) {
          hyderabadMapInstance.current.setCenter({ lat: 17.3850, lng: 78.4867 });
          hyderabadMapInstance.current.setZoom(11);
        }
        break;
      case 'tamilnadu':
        if (tamilnaduMapInstance.current) {
          tamilnaduMapInstance.current.setCenter({ lat: 11.0168, lng: 76.9558 });
          tamilnaduMapInstance.current.setZoom(10);
        }
        break;
      case 'pune':
        if (puneMapInstance.current) {
          puneMapInstance.current.setCenter({ lat: 18.5204, lng: 73.8567 });
          puneMapInstance.current.setZoom(11);
        }
        break;
      case 'other':
        if (otherMapInstance.current) {
          otherMapInstance.current.setCenter({ lat: 20.5937, lng: 78.9629 });
          otherMapInstance.current.setZoom(5);
        }
        break;
      default:
        break;
    }
  };

  const { userData } = useUser();
  const navigate = useNavigate();

  if (!userData) {
    return (
      <div className="loading-container">
        <div className="loading-spinner"></div>
        <p>Loading your dashboard...</p>
      </div>
    );
  }

  const hour = new Date().getHours();
  let greeting = 'Good morning';
  if (hour >= 12 && hour < 17) greeting = 'Good afternoon';
  else if (hour >= 17) greeting = 'Good evening';

  const namePart = userData.email
    ? userData.email.split('@')[0].replace(/[^a-zA-Z]/g, ' ')
    : 'there';
  const displayName = namePart.charAt(0).toUpperCase() + namePart.slice(1);

  const privilegesData = userData.privileges[0] || {};
  const totalPrivileges = Object.values(privilegesData).flat().length;
  const activeSections = Object.keys(privilegesData).length;

  return (
    <div className="enrollment-container">
      <div className="welcome-banner">
        <div className="welcome-content">
          <h1 className="welcome-heading">{greeting}, {displayName}!</h1>
          <p className="welcome-subheading">Welcome to your personalized dashboard</p>
        </div>
        <div className="user-badge" onClick={() => navigate('/profile')}>
          <div className="user-initial">{displayName[0]}</div>
          <div className="user-type-badge">{userData.userType}</div>
        </div>
      </div>

      <div className="dashboard-cards">
        <div className="dashboard-card" onClick={() => navigate('/profile')}>
          <div className="card-icon user-icon"></div>
          <div className="card-content">
            <h3>User Profile</h3>
            <p>View your account settings and information</p>
          </div>
        </div>

        <div className="dashboard-card">
          <div className="card-icon academy-icon"></div>
          <div className="card-content">
            <h3>Academy Access</h3>
            <p>
              {userData.userType === 'ADMIN'
                ? 'Full access to all academies'
                : (() => {
                    const count = userData.academyIds?.length || 0;
                    return `Access to ${count} ${count === 1 ? 'academy' : 'academies'}`;
                  })()}
            </p>
          </div>
        </div>

        <div className="dashboard-card">
          <div className="card-icon privileges-icon"></div>
          <div className="card-content">
            <h3>Your Privileges</h3>
            <p>Access to {totalPrivileges} privileges across {activeSections} sections</p>
          </div>
        </div>
      </div>
      
      <h2 style={{margin:0}}>Machaxi Centres</h2>
      <div className="dashboard">
        <div className="city-selector">
          <button 
            className={`city-tab ${activeCity === 'bangalore' ? 'active' : ''}`}
            onClick={() => handleCityChange('bangalore')}
          >
            Bangalore ({bangaloreLocations.length})
          </button>
          <button 
            className={`city-tab ${activeCity === 'hyderabad' ? 'active' : ''}`}
            onClick={() => handleCityChange('hyderabad')}
          >
            Hyderabad ({hyderabadLocations.length})
          </button>
          <button 
            className={`city-tab ${activeCity === 'tamilnadu' ? 'active' : ''}`}
            onClick={() => handleCityChange('tamilnadu')}
          >
            Coimbatore ({tamilnaduLocations.length})
          </button>
          <button 
            className={`city-tab ${activeCity === 'pune' ? 'active' : ''}`}
            onClick={() => handleCityChange('pune')}
          >
            Pune ({puneLocations.length})
          </button>
        </div>
        
        <div className="map-slider-container" ref={sliderRef}>
          <div className="map-slide">
            <div ref={bangaloreMapRef} className="google-map" />
          </div>
          <div className="map-slide">
            <div ref={hyderabadMapRef} className="google-map" />
          </div>
          <div className="map-slide">
            <div ref={tamilnaduMapRef} className="google-map" />
          </div>
          <div className="map-slide">
            <div ref={puneMapRef} className="google-map" />
          </div>
          {otherLocations.length > 0 && (
            <div className="map-slide">
              <div ref={otherMapRef} className="google-map" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CityMapSlider;